import React from 'react'
import { Link } from 'react-router-dom';
import { HashLink as Anchor } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import logo from '../../../logo.svg';

const LogoBar = props => {
    return (
        <div className={'logo-bar ' + (props.fixed ? 'logo-bar--fixed' : '')}>

            <div className="logo-bar__wrapper">
                <div className="logo-bar__icons">
                    <Link to={{pathname:"/"}}>
                        <FontAwesomeIcon icon={faHome} alt="home"/>
                    </Link>
                    <Anchor to="/#contact">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </Anchor>
                    
                    <a href="https://www.linkedin.com/in/alex-tarapacky/" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faLinkedin} style={{ height: "90%", paddingBottom: "5px"}} />
                    </a>
                </div>
                <Link to={{pathname:"/"}}>
                    <div className="logo-bar__logo">
                    <img src={logo} className="App-logo" alt="logo" />

                    </div>
                </Link>
            </div>
        </div>
    )
}

export default LogoBar